module.exports = __webpack_public_path__ + "static/media/warning-alert-new.18f01a2a.mp3";